import React, { useEffect, useState, useRef } from 'react';
import { ArticleService } from '../../../../../services/ArticleService';
import { EditionService } from '../../../../../services/EditionService';
import { Spinner, Card, Tabs, Tooltip, Row, Col, Accordion, Button, Table, Alert, Form, Dropdown, OverlayTrigger, Popover, InputGroup, FormControl } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../../error-manager/ErrorManager";
import ConfirmDialog from '../../../../confirm-dialog/ConfirmDialog';
import Pagination from '../../../../../components/pagination/Pagination';
import { currencyFormat, getFile } from '../../../../../helper/Helper'
import { GlobalContext } from "../../../../../services/GlobalProvider";
import SendMailDialog from "../../../../../components/send-mail-dialog/SendMailDialog";
import PeriodeFilter from "../../../../../components/periode-filter/PeriodeFilter";
import Split from '../../../../../components/split/Split';


const Proformas = (props) => {

    const { parametres } = React.useContext(GlobalContext);

    const [getProformasLoading, setGetProformasLoading] = useState(false)
    const [proformasData, setProformasData] = useState()
    const [globalError, setGlobalError] = useState()
    const [currentPagination, setCurrentPagination] = useState(1)
    const [sendMailDialog, setSendMailDialog] = useState({})

    const searchInput = useRef("");

    let proformasParams = useRef({
        'start': 0,
        'limit': 10,
        'family': null,
        'search': null,
        'filters': null,
        'sort': 'date',
        'order': 'desc',
        'fields': "_id,type,code,date,client_nom,client_id,observation,total_remise,total_taxes,statut,total_prix_revient,total_brut_ht,total_net_ht,total_ttc"
    });

    useEffect(() => {
        getProformas()
    }, []);

    function changePagination(p) {
        setCurrentPagination(p)
        proformasParams.current['start'] = (proformasParams.current.limit * p) - proformasParams.current.limit
    }

    function onChangePagination(p) {
        changePagination(p)
        getProformas()
    }

    let getProformasTimeOut;
    function getProformas() {
        window.clearTimeout(getProformasTimeOut);
        getProformasTimeOut = window.setTimeout(function () {
            setGetProformasLoading(true)
            setGlobalError()
            ArticleService.getProformas(props.folderId, props.article._id, proformasParams.current).then(res => {
                setGetProformasLoading(false)
                setProformasData(res.data ? res.data.data : null)
            }).catch(error => {
                setGetProformasLoading(false)
                setGlobalError(error)
            });
        }, 600);
    }

    function changeSearchValue(value) {
        proformasParams.current['search'] = value
        changePagination(1)
        proformasParams.current['start'] = 0
        getProformas()
    }

    function removeSearchValue() {
        searchInput.current.value = ""
        changeSearchValue()
    }

    function downloadPDF(proforma) {
        EditionService.getProforma(props.folderId, proforma._id, "pdf").then(res => {
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                getFile(res)
            }
        }).catch(async (error) => {
            if (
                error.request.responseType === 'blob' &&
                error.response.data instanceof Blob &&
                error.response.data.type &&
                error.response.data.type.toLowerCase().indexOf('json') != -1
            ) {
                setGlobalError({ response: JSON.parse(await error.response.data.text()) })
            } else {
                setGlobalError(error)
            }
        });
    }

    function sendEmail(proforma) {
        setSendMailDialog({
            "clientIdList": [proforma.client_id],
            "folderId": props.folderId,
            "editionUrl": "proformas",
            "params": {
                "filter": {
                    "_id": "=" + proforma._id
                }
            },
            "totalElements": 1,
            "show": true
        })
    }

    function setFilterDateDebut(date) {
        let filterDateStart = proformasParams.current?.filters?.['filter[date]']?.find((element) => element.operator == '>=')
        if (filterDateStart) {
            filterDateStart.value = date
        } else {
            if (proformasParams.current?.filters?.['filter[date]']) {
                proformasParams.current?.filters?.['filter[date]'].push({ operator: ">=", value: date })
            } else {
                proformasParams.current['filters'] = { 'filter[date]': [{ operator: ">=", value: date }] }
            }
        }
    }

    function setFilterDateFin(date) {
        let filterDateEnd = proformasParams.current?.filters?.['filter[date]']?.find((element) => element.operator == '<=')
        if (filterDateEnd) {
            filterDateEnd.value = date
        } else {
            if (proformasParams.current?.filters?.['filter[date]']) {
                proformasParams.current?.filters?.['filter[date]'].push({ operator: "<=", value: date })
            } else {
                proformasParams.current['filters'] = { 'filter[date]': [{ operator: "<=", value: date }] }
            }
        }
    }

    function changeDate(dateObject) {
        delete proformasParams.current?.filters?.['filter[date]']
        if (dateObject.dateDebut) {
            setFilterDateDebut(dateObject.dateDebut)
        }
        if (dateObject.dateFin) {
            setFilterDateFin(dateObject.dateFin)
        }
        changePagination(1)
        getProformas()
    }

    return (
        <>
            {globalError && <ErrorManager error={globalError} />}
            <SendMailDialog clientIdList={sendMailDialog.clientIdList} folderId={sendMailDialog.folderId} editionUrl={sendMailDialog.editionUrl} params={sendMailDialog.params} totalElements={sendMailDialog.totalElements} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />
            {!globalError &&
                <span className='mb-3 d-block'>
                    <div className="bg-gray-100 p-3 rounded mt-3">
                        <Row className="mb-3">
                            <InputGroup>
                                <i className="material-icons input-icon text-gray-400">search</i>
                                <FormControl
                                    ref={searchInput}
                                    className="rounded-start input-icon-space"
                                    placeholder="Rechercher"
                                    type="text"
                                    onChange={e => changeSearchValue(e.target.value)}
                                />
                                {searchInput.current.value &&
                                    <Button className="border border-start-0" variant="gray-100" onClick={() => removeSearchValue()}><i className="material-icons">close</i></Button>
                                }
                            </InputGroup>
                        </Row>
                        <PeriodeFilter onDateChange={(dateObject) => changeDate(dateObject)} />
                    </div>
                </span>

            }

            {getProformasLoading && <span className="hloader"></span>}

            {(!getProformasLoading && (proformasData?.count == 0 || !proformasData?.count) && !globalError) && <em>- Aucun élément trouvé -</em>}

            {(!getProformasLoading && !globalError && proformasData?.proformas.length > 0) &&
                <>
                    <Row className="mb-4" >
                        <Col>
                            <Split title={`Chiffre d'affaire HT (${parametres?.general?.devise_dossier})`} border value={currencyFormat(proformasData.chiffre_affaire_ht)} />
                            <Split title="Quantité vendue" value={proformasData.quantite_vendue} />
                        </Col>
                    </Row>
                    <Accordion>
                        {proformasData?.proformas.map(proforma => (
                            <Accordion.Item key={proforma._id} eventKey={proforma._id} className="border-0 mb-2">
                                <Accordion.Header>
                                    <span className="d-flex w-100">{proforma.client_nom} le {new Date(proforma.date).toLocaleDateString()} <span className="ms-auto me-4 text-gray-600">{currencyFormat(proforma.total_ttc)} {parametres?.general?.devise_dossier} TTC</span></span>
                                </Accordion.Header>
                                <Accordion.Body className="px-1">
                                    <div className="d-flex align-items-center py-2">
                                        <div className="me-auto">
                                            <p className="m-0">{proforma.client_nom}</p>
                                            <p className="m-0">{proforma.type} {proforma.code}</p>
                                        </div>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                                <i className="material-icons i-lg">more_horiz</i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item target="_blank" href={`/${props.folderId}/proformas?proformaId=${proforma._id}`}>Afficher</Dropdown.Item>
                                                <Dropdown.Item onClick={() => downloadPDF(proforma)}>Imprimer</Dropdown.Item>
                                                <Dropdown.Item onClick={() => sendEmail(proforma)}>Envoyer par mail</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <Row>
                                        <Col>
                                            {/* <Split border title="Type" value={proforma.type} />
                                            <Split border title="Code" value={proforma.code} /> */}
                                            <Split border title="Date" value={new Date(proforma.date).toLocaleString()} />
                                            <Split border title="Client nom" value={proforma.client_nom} />
                                            <Split border title="Observation" value={proforma.observation} />
                                            <Split border title={`Total prix revient (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_prix_revient)} />
                                            <Split border title={`Total brut hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_brut_ht)} />
                                            <Split border title={`Total net hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_net_ht)} />
                                            <Split border title={`Total remise (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_remise)} />
                                            <Split border title={`Total montant taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_taxes?.montant_total)} />
                                            <Split border title={`Total TTC (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_ttc)} />
                                            <Split border title="Statut" value={proforma.statut} />
                                        </Col>
                                    </Row>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                    <Pagination className="mt-3" itemsLength={proformasData?.total} elementsPerPage={proformasParams.current.limit} currentPagination={currentPagination} changePagination={p => onChangePagination(p)} />
                </>
            }
        </>
    );
}
export default Proformas;